(function () {
  var root = document.querySelector('[data-vpp-root]');
  if (!root) return;

  var tabBtns = root.querySelectorAll('[data-vpp-tab]');
  var tabPanels = root.querySelectorAll('[data-vpp-panel]');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-vpp-tab');
      tabBtns.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      tabPanels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-vpp-panel') === target);
      });
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  });

  var subnavLinks = root.querySelectorAll('[data-vpp-subnav] a');
  if ('IntersectionObserver' in window && subnavLinks.length) {
    var sections = [];
    subnavLinks.forEach(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var section = id && document.getElementById(id);
      if (section) sections.push(section);
    });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          subnavLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  var lightboxRoot = root.querySelector('[data-vpp-lightbox-root]');
  var lightboxItems = Array.prototype.slice.call(root.querySelectorAll('[data-vpp-slide]'));
  var lightboxImg = root.querySelector('[data-vpp-lightbox-img]');
  var lightboxCaption = root.querySelector('[data-vpp-lightbox-caption]');
  var lightboxIndex = 0;

  function showLightbox(index) {
    if (!lightboxRoot || !lightboxItems.length) return;
    lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
    var item = lightboxItems[lightboxIndex];
    var src = item.getAttribute('data-vpp-src');
    if (!src) return;
    lightboxImg.src = src;
    lightboxImg.alt = item.getAttribute('data-vpp-alt') || '';
    if (lightboxCaption) lightboxCaption.textContent = item.getAttribute('data-vpp-alt') || '';
    lightboxRoot.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hideLightbox() {
    if (!lightboxRoot) return;
    lightboxRoot.hidden = true;
    document.body.style.overflow = '';
  }

  lightboxItems.forEach(function (item, i) {
    item.addEventListener('click', function () {
      showLightbox(i);
    });
  });

  if (lightboxRoot) {
    var closeBtn = lightboxRoot.querySelector('[data-vpp-lightbox-close]');
    var lbPrev = lightboxRoot.querySelector('[data-vpp-lightbox-prev]');
    var lbNext = lightboxRoot.querySelector('[data-vpp-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', hideLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function () { showLightbox(lightboxIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showLightbox(lightboxIndex + 1); });
    lightboxRoot.addEventListener('click', function (e) {
      if (e.target === lightboxRoot) hideLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (lightboxRoot.hidden) return;
      if (e.key === 'Escape') hideLightbox();
      if (e.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
      if (e.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var form = root.querySelector('[data-vpp-form]');
  var errorEl = root.querySelector('[data-vpp-error]');
  var submitBtn = root.querySelector('[data-vpp-submit]');
  var klaviyoEl = root.querySelector('[data-vpp-klaviyo]');
  var klaviyoCfg = { publicKey: '', listId: '', phone: '07 5500 0095' };

  try {
    if (klaviyoEl) klaviyoCfg = JSON.parse(klaviyoEl.textContent);
  } catch (e) {
    /* keep defaults */
  }

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (!klaviyoCfg.publicKey || !klaviyoCfg.listId || String(klaviyoCfg.publicKey).indexOf('YOUR_') === 0) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'Enquiry form is not configured yet. Call us on ' + (klaviyoCfg.phone || '07 5500 0095') + '.';
      }
      return;
    }

    var data = new FormData(form);
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: data.get('form_source') || 'Truck for sale',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.get('email'),
                first_name: (data.get('full_name') || '').split(' ')[0] || '',
                last_name: (data.get('full_name') || '').split(' ').slice(1).join(' ') || '',
                phone_number: data.get('phone'),
                properties: {
                  Form_Source: data.get('form_source') || 'Truck for sale',
                  Vehicle_Title: data.get('vehicle_title') || '',
                  Vehicle_SKU: data.get('vehicle_sku') || '',
                  Vehicle_Price: data.get('vehicle_price') || '',
                  Inquiry_Type: data.get('inquiry_type') || '',
                  Preferred_Workshop: data.get('preferred_workshop') || 'arundel',
                  Questions_Comments: data.get('questions_comments') || '',
                  Page_URL: window.location.href,
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: klaviyoCfg.listId } },
        },
      },
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCfg.publicKey, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.status === 202 || res.status === 200 || res.status === 204) {
          var title = escapeHtml(data.get('vehicle_title') || 'this truck');
          form.innerHTML =
            '<div class="vpp-form__success">' +
            '<h2>Thank you</h2>' +
            '<p>Your enquiry about <strong>' +
            title +
            '</strong> is in. The Tough Trucks team will be in touch shortly.</p>' +
            '</div>';
        } else {
          throw new Error(String(res.status));
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send enquiry';
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            'There was an error submitting the form. Please try again or call us on ' +
            (klaviyoCfg.phone || '07 5500 0095') +
            '.';
        }
      });
  });
})();
